import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { queries } from '@/lib/api';
import { money } from '@/lib/format';
import stadium from '@/assets/hero-jogadores.jpg';
import { SecaoSobre } from '@/components/template/SecaoSobre';
import { SecaoTransmissao } from '@/components/template/SecaoTransmissao';
import { SecaoTorneios } from '@/components/template/SecaoTorneios';
import { SecaoComunidade } from '@/components/template/SecaoComunidade';
import { SecaoPerguntas } from '@/components/template/SecaoPerguntas';
import { RodapeTemplate } from '@/components/template/RodapeTemplate';
import { SecaoParceiros, SecaoDepoimentos, SecaoNoticias, SecaoMarca } from '@/components/template/SecoesEditoriais';
import { useGatilhosSempreEmDia } from '@/components/template/animacoes';
import '@/styles/home-arena.css';

const date = (value: number | null) => value ? new Date(value * 1000).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit', timeZone: 'America/Sao_Paulo' }) : 'Data a definir';
function Arrow() { return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M4 12h16m-6-6 6 6-6 6" /></svg>; }
const title = (name: string) => (name.split('|')[0] ?? name).replace(/[\p{Extended_Pictographic}\uFE0F]/gu, '').trim();

export function HomePage() {
  useGatilhosSempreEmDia();
  const { data, isLoading, isError, refetch } = useQuery(queries.tournaments());
  const editions = data?.tournaments ?? [];
  const open = editions.filter(t => t.status === 'registration').sort((a, b) => (a.startsAt ?? Infinity) - (b.startsAt ?? Infinity));
  const featured = open.find(t => t.spotsLeft > 0) ?? open[0];
  const target = featured ? `/campeonatos/${featured.slug}${featured.spotsLeft > 0 ? '/inscricao' : ''}` : '/campeonatos';
  return <div className="arena-home">
    <div className="arena-first-screen">
    <section className="arena-hero" aria-labelledby="arena-title">
      <div className="arena-art" aria-hidden="true"><img src={stadium} alt="" fetchPriority="high" /><span /></div>
      <div className="arena-wrap arena-hero-content"><div className="arena-intro">
        <h1 id="arena-title">A casa dos<br />campeonatos de<br /><em>Pro Clubs.</em></h1>
        <p>O seu time. A sua torcida. A próxima conquista.<br />Entre em campo e faça parte da Hexa Cup.</p>
        <div className="arena-actions"><Link className="arena-button" to={target}>{featured && featured.spotsLeft > 0 ? 'Inscrever meu time' : 'Ver campeonatos'} <Arrow /></Link><Link className="arena-button arena-button-outline" to="/cadastrar-time">Criar meu time <Arrow /></Link></div>
        <div className="arena-platforms"><span>EA SPORTS FC</span><span>PS5</span><span>Xbox Series X|S</span><span>PC</span></div>
      </div><p className="arena-art-caption" aria-hidden="true">Compita.<br />Supere.<br /><strong>Conquiste.</strong></p></div>
    </section>
    <div className="arena-wrap">
      <section className="arena-feature" aria-label="Campeonato em destaque" aria-busy={isLoading}>
        <img className="arena-feature-crest" src="/logo.webp" alt="" />
        <div className="arena-feature-title"><span className="arena-status">{featured ? 'Inscrições abertas' : 'Próxima edição'}</span><h2>{isLoading ? 'Buscando campeonato…' : isError ? 'Não foi possível carregar' : featured ? title(featured.name) : 'O próximo desafio vem aí.'}</h2>{!featured && !isLoading && <p>{isError ? 'Tente novamente para consultar as edições.' : 'Acompanhe os anúncios e prepare o seu time.'}</p>}</div>
        {featured && <dl className="arena-feature-data"><div><dt>Início · Brasília</dt><dd>{date(featured.startsAt)}</dd></div><div><dt>Inscrição por time</dt><dd>{featured.entryFeeCents ? money(featured.entryFeeCents) : 'Grátis'}</dd></div>{featured.prizePoolCents > 0 && <div><dt>Premiação</dt><dd className="arena-prize">{money(featured.prizePoolCents)}</dd></div>}</dl>}
        {isError ? <button className="arena-button" onClick={() => void refetch()}>Tentar novamente <Arrow /></button> : <Link className="arena-button" to={target}>{featured && featured.spotsLeft > 0 ? 'Inscrever meu time' : 'Ver campeonatos'}<Arrow /></Link>}
      </section>
    </div>
    </div>
    <div className="mpc-template arena-sections">
      <SecaoSobre />
      <SecaoTransmissao />
      <SecaoTorneios />
      <SecaoComunidade />
      {/* Planos e highlights já estavam ocultos antes deste redesign. */}
      <SecaoParceiros />
      <SecaoDepoimentos />
      <SecaoNoticias />
      <SecaoPerguntas />
      <SecaoMarca />
      <RodapeTemplate />
    </div>
  </div>;
}
